import React from "react";

function Icon(data) {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 42.54 41.08"
        width={data.w} height={data.h}
      >
        <defs>
          <style>
            {
              ".cls-1{stroke:#ff8400;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke:#3d3833;}"
            }
          </style>
        </defs>
        <line className="cls-2" x1={32.74} y1={18.26} x2={40.42} y2={18.26} />
        <polyline className="cls-2" points="38.1 15.38 40.72 18.31 38.1 21.23" />
        <line className="cls-2" x1={30.59} y1={27.16} x2={36.23} y2={32.8} />
        <polyline className="cls-2" points="36.57 29.17 36.42 33.04 32.54 33.2" />
        <line className="cls-2" x1={29.97} y1={10} x2={36.25} y2={3.72} />
        <polyline className="cls-2" points="32.62 3.38 36.49 3.54 36.65 7.41" />
        <line className="cls-2" x1={10.21} y1={18.26} x2={2.53} y2={18.26} />
        <polyline className="cls-2" points="4.85 15.38 2.23 18.31 4.85 21.23" />
        <line className="cls-2" x1={12.36} y1={27.16} x2={6.72} y2={32.8} />
        <polyline className="cls-2" points="6.38 29.17 6.53 33.04 10.41 33.2" />
        <line className="cls-2" x1={12.98} y1={10} x2={6.7} y2={3.72} />
        <polyline className="cls-2" points="10.33 3.38 6.46 3.54 6.3 7.41" />
        <g>
          <circle className="cls-1" cx={21.51} cy={4.52} r={3.95} />
          <path
            className="cls-1"
            d="M17.01,26.23h0c-1.51,0-2.88-.91-3.39-2.33-.16-.45-.25-.92-.27-1.4l-.24-6.88c-.06-1.82,1.21-3.49,3.15-4.04,1.25-.36,2.96-.62,5.23-.62,2.28,0,3.97,.28,5.22,.64,1.94,.56,3.2,2.24,3.12,4.06l-.3,6.88c-.02,.54-.15,1.08-.36,1.58-.54,1.31-1.83,2.15-3.25,2.15h0"
          />
          <path
            className="cls-1"
            d="M21.42,28.33l-.04,10.72c0,.81,.65,1.46,1.46,1.46h1.26c.79,0,1.44-.63,1.46-1.42l.55-22.41"
          />
          <path
            className="cls-1"
            d="M16.81,16.66l.39,22.43c.01,.8,.66,1.43,1.46,1.43h1.26c.81,0,1.46-.65,1.46-1.46v-2.44"
          />
        </g>
      </svg>

  );
}

export default Icon;
